import { render } from "./EditVillagerModal.vue?vue&type=template&id=68c21d06&scoped=true"
import script from "./EditVillagerModal.vue?vue&type=script&lang=js"
export * from "./EditVillagerModal.vue?vue&type=script&lang=js"

import "./EditVillagerModal.vue?vue&type=style&index=0&id=68c21d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c21d06"]])

export default __exports__